var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-form',{attrs:{"loading":_vm.loading,"progress":_vm.progress,"size":_vm.$store.state.app.uploadMaxFileSize},on:{"onSubmitForm":_vm.submitForm}})}
var staticRenderFns = []

export { render, staticRenderFns }